// src/App.jsx
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Browse from "./pages/Browse";
import CatProfile from "./pages/CatProfile";
import AdoptChat from "./pages/AdoptChat";
import SubmitCat from "./pages/SubmitCat";
import OwnerDashboard from "./pages/OwnerDashboard";
import OwnerLogin from "./pages/OwnerLogin";
import DecisionPage from "./pages/DecisionPage";
import "./index.css";

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/"                  element={<Browse />} />
        <Route path="/cat/:id"           element={<CatProfile />} />
        <Route path="/adopt/:id"         element={<AdoptChat />} />
        <Route path="/submit"            element={<SubmitCat />} />
        <Route path="/dashboard"         element={<OwnerDashboard />} />
        <Route path="/login"             element={<OwnerLogin />} />
        <Route path="/decision/:token"   element={<DecisionPage />} />
      </Routes>
    </BrowserRouter>
  );
}
